/* eslint-disable default-case */
import { SPE_ACCOUNT_ID } from '@ubeya/shared/utils/accounts';
import { mappedArray } from '@ubeya/shared/utils/array';

export const conditionalColumns = (item, columns) => {
  const mappedColumns = mappedArray(
    columns,
    ({ dataKey }) => dataKey,
    ({ Header }) => Header
  );

  return Object.entries(item).reduce((prev, [key, value]) => {
    if (!mappedColumns[key]) {
      return prev;
    }
    return { ...prev, [mappedColumns[key]]: value };
  }, {});
};

const COLUMN_HEADER_OVERRIDES = { totalHours: 'totalTime' };

export const columnHeaderKey = (column) => COLUMN_HEADER_OVERRIDES[column] || column;

export const generateColumnData = ({ column, isCustomColumnGeneration, accountId, t }) => {
  if (column.dataKey) {
    return column;
  }

  if (isCustomColumnGeneration) {
    switch (accountId) {
      case SPE_ACCOUNT_ID:
        return {
          Header: t(column === 'totalPayroll' ? 'totalPay' : columnHeaderKey(column)),
          dataKey: column
        };
    }
  }

  return {
    Header: t(columnHeaderKey(column)),
    dataKey: column
  };
};
